import React from 'react'

import './Blocked.scss'
import { l } from './Translation'

const Blocked = () => {
  return (
    <div className="blocked-container">
      <div className="blocked-box">
        <img className="blocked-icon" src={'/images/blocked-icon.svg'} />
        <h1 className="blocked-title">{l('blocked.title')}</h1>
        <div className="blocked-text" dangerouslySetInnerHTML={{ __html: l('blocked.text') }} />
      </div>
    </div>
  )
}

export default Blocked
